import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { DocumentUploadService } from '@xengage/gw-portals-document-js';

export default class PolicyService {
    static getAccountPolicySummaries(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummaries', [], authHeader);
    }

    static getAccountPolicySummariesSnapshot(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummariesSnapshot', [], authHeader);
    }

    static getAllAvailableAccountPolicySummaries_Ext(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAllAvailableAccountPolicySummaries_Ext', [], authHeader);
    }

    static getAccountPolicySummaries_Ext(accountNumber ,authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummaries_Ext', [accountNumber], authHeader);
    }

    static getAccountPolicyDetails(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyDetails', [policyNumber], authHeader);
    }

    static getPolicyDetails(policyNumber,termNumber,isODSPolicy,effectiveDate,expirationDate, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getPolicyDetails', policyNumber,termNumber,isODSPolicy,effectiveDate,expirationDate,authHeader);
    }

    static removeDocument(publicID, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('removePolicyDocument'), 'removeDocument', [publicID], authHeader);
    }

    static uploadDocument(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadPolicyDocument'), document, documentMetadata, authHeader);
    }

    static getDocumentUploadToken(params, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('generateUploadToken'), 'generateUploadToken', params, additionalHeaders);
    }

    static getAccountPolicySummariesForPayroll( additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummariesForPayroll', [], additionalHeaders);
    }

    static getPolicySummariesForPayrollSecure_Ext(PolicyNumber,additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getPolicySummariesForPayrollSecure_Ext', [PolicyNumber], additionalHeaders);
    }

    static getPolicyLocations(policyNumber,lossDate, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getPolicyLocations', [policyNumber,lossDate], additionalHeaders);
    }

    static getPremiumAuditStatusesByPolicyNumber(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('premiumAudit'),
            'getPremiumAuditStatusesForPolicyNumbers', [policyNumber], additionalHeaders);
    }

    static getPremiumAuditStatusesByProducerCodes(producerCodes, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('premiumAudit'),
            'getPremiumAuditStatusesForProducerCodes', [producerCodes], additionalHeaders);
    }

    static getPremiumAuditStatusesByAccountNumber(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('premiumAudit'),
            'getPremiumAuditStatusesForAccount', [accountNumber], additionalHeaders);
    }

    static getPremiumAuditStatusesByUser(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('premiumAudit'),
            'getPremiumAuditStatusesForEffectiveUser', additionalHeaders);
    }

    static getPremiumAuditDocsByAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('premiumAudit'),
            'getPremiumAuditDocsForAccount', [accountNumber], additionalHeaders);
    }
}
